import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

export interface FieldGroupProps {
  title: string;
  children: React.ReactNode;
}

/**
 * A labelled run of related fields inside a panel.
 *
 * Deliberately lighter than `Panel` — an eyebrow and a hairline, no card. These
 * sit *within* one panel on the structure detail page, so a second bordered box
 * per group would read as four cards stacked inside a fifth.
 */
export const FieldGroup: React.FC<FieldGroupProps> = ({ title, children }) => (
  <Box component="section" aria-label={title}>
    <Typography
      sx={{
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: 'text.secondary',
        pb: 0.75,
        mb: 1.5,
        borderBottom: 1,
        borderColor: 'v4.border',
      }}
    >
      {title}
    </Typography>
    {children}
  </Box>
);
